import auth0 from 'js/brand_auth0_client';
import gqlClient from 'js/graphql/client/gqlClient';
import {getAuth0Storage, removeAuth0Storage, setAuth0Storage} from 'js/auth0_storage';
import {runInAction} from 'mobx';
import * as environmentHelper from 'js/environmentHelper';

export default async function checkBrandUserSession() {
    let accessToken;

    try {
        accessToken = await auth0.getTokenSilently({
            redirect_uri: `https://${window.location.host}/brands/login`
        });
        const authCache = getAuth0Storage();
        const auth0Profile = authCache.auth0Profile || (await auth0.getUser());
        setAuth0Storage({
            auth0Profile,
            accessToken
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        removeAuth0Storage();
        window.location.replace(
            `https://${window.location.host}/brands/login?returnTo=${window.location.href}`
        );
    }

    if (!accessToken) {
        return;
    }

    runInAction( async () => {
        await gqlClient.setUri(environmentHelper.graphqlGatewayUrl);
        if (accessToken) {
            runInAction( async () => {
                gqlClient.setAccessToken(accessToken);
                if (!gqlClient.client) {
                    await gqlClient.createClient();
                }
            })
        }
    })
}



// WEBPACK FOOTER //
// ./brand_session.js